/**
 * Returns concatenated string separated by space symbol
 * for className element attr usage
 * */

export const clss = (classNames: (string | undefined)[]) => {
    return classNames.join(' ');
};